import { View } from "@/components/ui/view";
import i18n from 'i18n-js';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Footer from "@/components/basic/Footer";
import InAInfo from '@/components/basic/InAInfo';
import * as Speech from 'expo-speech';
import { taskDone } from "@/stores/mainSlice";

export default function Finished({ route, navigation }) {
    const { taskid, title, isSimulator } = route.params
    const dispatch = useDispatch()

    const settings = useSelector((state) => state.settings)

    useEffect(() => {
        if (settings.speechEnabled) {
            Speech.stop()
        }
    }, [])

    const finishTask = () => {
        dispatch(taskDone({ taskid: taskid, abort: false }))
    }

    const actionStopTask = () => {
        dispatch(taskDone({ taskid: taskid, abort: true }))
    }

    const actions = [
        { icon: 'keyboard-arrow-up', text: 'footer.prevStep', component: 'BACK' },
        isSimulator ? { icon: 'refresh', text: 'footer.restart', component: 'ShowWorkflow2', params: { taskid: taskid, isSimulator: true }, exec: actionStopTask } : 
            { icon: 'home', text: 'footer.home', component: 'Home', exec: finishTask },
        isSimulator ? { icon: 'check', text: 'footer.finish', component: 'ShowWorkflow2', params: { taskid: taskid, isSimulator: true  }, exec: actionStopTask } : 
            { icon: 'check', text: 'footer.finish', component: 'Home', exec: finishTask }
    ]

    return (
        <View className="flex-1 bg-secondary-50">
            <InAInfo info={i18n.t('finishedScreen.info', { title: title })} pose={2} />
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}
